module.exports = __webpack_public_path__ + "img/sweden-respiratory-diseases-male.792decd7.png";